import { sendAjaxDataToWP } from "./sendAjaxDataToWP";
import { delay } from "./Utils";

const AskExpert = (modal) => {
  const forms = document.querySelectorAll(".js-ask_expert");
  forms.forEach((form) => {
    let content = document.getElementById("ask-expert-content");
    let spinner = document.getElementById("ask-expert-spinner");
    form.addEventListener("submit", (ev) => {
      ev.preventDefault();
      spinner.classList.remove("hidden!");
      content.innerHTML = "";
      const data = new FormData(form);
      data.append("action", "ask_expert");
      //console.log([...data]);
      sendAjaxDataToWP(data)
        .then((result) => {
          if (result) {
            //("Data received from server:", result);
          }
          delay(1000).then(() => {
            content.innerHTML = result.data;
            spinner.classList.add("hidden!");
          });
        })
        .catch((error) => {
          console.error("Global Error Handler:", error);
        });
    });
  });
};

export { AskExpert };
